export default [
    {
        name: 'DS_TIPO',
        label: 'Tipo'
    },
    {
        name: 'DT_EVENTO',
        label: 'Data'
    },
    {
        name: 'DS_LOG',
        label: 'Descrição'
    },
];